import { render, staticRenderFns } from "./MessActivateButton.vue?vue&type=template&id=0915820f&scoped=true&"
import script from "./MessActivateButton.vue?vue&type=script&lang=js&"
export * from "./MessActivateButton.vue?vue&type=script&lang=js&"
import style0 from "./MessActivateButton.vue?vue&type=style&index=0&id=0915820f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0915820f",
  null
  
)

export default component.exports